import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { useProvider } from '..';
import { requestBookingGroups, selectBookingGroupList } from '~/store/payments';

export function useBookingGroups() {
  const dispatch = useDispatch();
  const { currentProvider } = useProvider();

  const bookingGroupsList = useSelector(selectBookingGroupList);

  const getBookingGroups = bindActionCreators(requestBookingGroups, dispatch);

  useEffect(() => {
    if (!currentProvider) {
      return;
    }
    getBookingGroups(currentProvider.domain);
  }, [currentProvider?.domain]);

  return {
    bookingGroupsList,
  };
}
